import React from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faDesktop } from "@fortawesome/free-solid-svg-icons";

const Project = ({ id, name, url, url1, skills, des }) => {
  return (
    <div data-aos="fade-up" className=" col-12 col-lg-4 project-card">
      <div className="image-project">
        <div className={`img-pro ${id}`}></div>
      </div>
      <div>
        <span>
          <a
            title={url}
            className="project-name"
            rel="noopener noreferrer"
            href={url}
            target="_blank"
          >
            <h2>{name}</h2>
          </a>

          <a style={{ margin: "20px" }} href={url1}  target="_blank">
            <FontAwesomeIcon icon={faCode} />
          </a>
          <a href={url}  target="_blank">
            <FontAwesomeIcon icon={faDesktop} />
          </a>
        </span>
      </div>

      {skills && <h3>{skills.map((skill) => skill)}</h3>}
      <p>{des}</p>
    </div>
  );
};

const Miscellaneous = ({ id, name, url, url1, skills, des }) => {
  return (
    <div id="b1" data-aos="fade-up" className=" col-12 col-lg-4 project-card">
      <div className="image-project">
        <div className={`img-pro ${id}`}></div>
      </div>
      <a
        title={url}
        className="project-name"
        rel="noopener noreferrer"
        target="_blank"
        href={url}
      >
        <h2>{name}</h2>
      </a>

      {skills && <h3>{skills.map((skill) => skill)}</h3>}
      <p>{des}</p>
    </div>
  );
};

export { Project, Miscellaneous };
